import { StorageManager } from 'src/app/common/storage-manager.class';
import { environment } from 'src/environments/environment';

export class FertilizantesEnvironmentDefinition {
    public rol = StorageManager.getUser().rol;
    
    public appName = environment.appName;
    
    public applicationType = environment.features.applicationType;
    
    public auxServerUrl = environment.serverUrl;
    
    public hasClients = environment.features.hasClients;
    
    public userCanSeeClientes = environment.features.userCanSeeClientes
        ? true
        : this.rol === 'admin';
    
    public hasFincas = environment.features.hasFincas;
    
    public showSectores = environment.features.showSectores;
    
    public showFertilizantesFormShort = environment.features.showFertilizantesFormShort;
    
    public showFertilizantesParcelas = environment.features.showFertilizantesParcelas;
    
    public showFertilizantesSectores = environment.features.showFertilizantesSectores;
    
    public fincaName = environment.features.fincaName;
    
    public fincasName = environment.features.fincasName;
    
    public sectorName = environment.features.sectorName;
    
    public sectoresName = environment.features.sectoresName;
    
    public parcelaName = environment.features.parcelaName;
    
    public parcelasName = environment.features.parcelasName;
    
    public showFertiNombreCuba = environment.features.showFertiNombreCuba;
    
    public showTareasFertiDias = environment.features.showTareasFertiDias;
    
    public showTareasFertiObservaciones = environment.features.showTareasFertiObservaciones;
    
    public showTareasFertiConsumoAgua = environment.features.showTareasFertiConsumoAgua;
    
    public showTareasFertiGramos = environment.features.showTareasFertiGramos;
    
    public showTipoFertilizacion = environment.features.showTareasFertilizantesTipoFertilizacion;
    
    public showTareasProcura = environment.features.showTareasProcura;
    
    public textoSuperficie = environment.features.textoSuperficie;
    
    public showClientesNotas = environment.features.showClientesNotas;
    
    public showCostes = environment.features.showCostes;
    
    public showTareasFertiSectorMultiple = environment.features.showTareasFertiSectorMultiple;

    // Para los usuarios de user debes especificar la horas de inicio y fin para el cliente AVA
    public activateRequireHourForRolUser =
        this.appName === 'ava'
        ? StorageManager.getUser().rol !== 'admin'
        : false;

    public showTareasMto = environment.features.showTareasMto;

    public activateREA = environment.features.activateREA;

    public timeStartStopTareas = environment.features.timeStartStopTareas;
    
    public showTareasFertiHoras = environment.features.showTareasFertiHoras;

    public tareasHorasTotales = environment.features.tareasHorasTotales;

    public showTrabajadoresFertilizantes = environment.features.showTrabajadoresFertilizantes;

    public showTareasAplicados = environment.features.showTareasAplicados;

    public showAssignUserTasksFertilizante = environment.features.showAssignUserTasksFertilizante;
                      
    public showAssignUserInAllTasks = environment.features.showAssignUserInAllTasks;

    public serverUrl = environment.serverUrl;

    public horaFechaFinActualPorDefecto =
      environment.features.horaFechaFinActualPorDefecto;

    public tipoSuperficieParcelas = environment.features.hasSuperficieCultivada
      ? 'Sup.\xa0Cultivada'
      : 'S.\xa0Sigpac';

    public showAbonado = environment.features.showAbonado;

    public showFertilizantesNPK = environment.features.showFertilizantesNPK;

    public showFertilizantesCa = environment.features.showFertilizantesCa;

    public showFertilizantesS = environment.features.showFertilizantesS;

    public showFertilizantesMg = environment.features.showFertilizantesMg;

    public udsByParcela = environment.features.showUnidadesFertilizantesByParcela;

    public showKilosHectarea = environment.features.showKilosHectarea;

    public showRecetaFertiAgrogest = environment.features.showRecetaFertiAgrogest;

    public clienteName = environment.features.clienteName;

    public canAddTareas = environment.features.canAddTareas;

    public selectedYears = 0;

    public modalShowCampaign  = false;

    public showCampaign = environment.features.showTareasFertilizantesCampaign;

    public logoUrl = environment.logoUrl;
    
    public canDuplicateTareas = environment.features.canDuplicateTareas;

    public showRecetaFertiPascualCabedo = environment.features.showRecetaFertiPascualCabedo;

    public showEnviarWhatsapp = environment.features.showEnviarWhatsapp;

    public showEnviarCorreo = environment.features.showEnviarCorreo;

    public showFertilizantesAlbaranFactura = environment.features.showFertilizantesAlbaranFactura;

    public showTareasBioExportCsv = environment.features.showTareasBioExportCsv;

    public betweenDates = environment.features.showTareasFitoBetweenDates;

    public showTareasPrioridad = environment.features.showTareasPrioridad;
    
    public showAssignUserTasksFitosanitario = environment.features.showAssignUserTasksFitosanitario
}// class;